import {
  AUTHENTICATING_TEAMS_REQUEST,AUTHENTICATING_TEAMS_SUCCEDDED,AUTHENTICATING_TEAMS_FAILED,
  UPDATING_TEAMS_REQUEST, UPDATING_TEAMS_SUCCEDDED, UPDATING_TEAMS_FAILED,
  UPDATING_TEAMS_RECORDING_TOGGLE_REQUEST, UPDATING_TEAMS_RECORDING_TOGGLE_SUCCEEDED, UPDATING_TEAMS_RECORDING_TOGGLE_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
changes: {
  saving: false,
  error: null
},
authentication: {
  authenticating: false,
  error: null
},
recordingEnabled: {
  loading: false,
  enabled: null,
  error: null,
},
};

function teamsReducer(state = initialState, action) {
switch (action.type) {
  case AUTHENTICATING_TEAMS_REQUEST:
    return Object.assign({}, state, {
      ...state,
      authentication: {
        authenticating: true,
        error: null
      }
    })
  case AUTHENTICATING_TEAMS_SUCCEDDED:
    return Object.assign({}, state, {
      ...state,
      authentication: {
        authenticating: false,
        error: null
      }
    })
  case AUTHENTICATING_TEAMS_FAILED:
    return Object.assign({}, state, {
      ...state,
      authentication: {
        authenticating: false,
        error: action.payload
      }
    }) 
  case UPDATING_TEAMS_REQUEST:
    return Object.assign({}, state, {
      ...state,
      changes: {
        saving: true,
        error: null
      }
    })
  case UPDATING_TEAMS_SUCCEDDED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        saving: false,
        error: null
      }
    })
  case UPDATING_TEAMS_FAILED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        saving: false,
        error: action.payload
      }
    })

  
    case UPDATING_TEAMS_RECORDING_TOGGLE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        recordingEnabled: {
          ...state.recordingEnabled,
          loading: true,
          error: null,
        },
      });

    case UPDATING_TEAMS_RECORDING_TOGGLE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        recordingEnabled: {
          ...state.recordingEnabled,
          loading: false,
          enabled: action.payload.data.configuration.callRecordingEnabled,
          error: null,
        },
      });

    case UPDATING_TEAMS_RECORDING_TOGGLE_FAILED:
      return Object.assign({}, state, {
        ...state,
        recordingEnabled: {
          ...state.recordingEnabled,
          loading: false,
          error: action.payload,
        },
      });

  default:
    return state;
}
}

export { teamsReducer };
